<template>
	<div>
		<p class="add-event-tip-title">About Event &amp; Experience types…</p>
		<p class="add-event-tip-content">We recommend that new hosts begin with the classic WRKPRTY coworking event before hosting other types of events. It’s the best way get started and get a feel for hosting.</p>
		<p class="add-event-tip-content">More experienced hosts are encouraged to try out our other formats - a good way to connect your local community in new and interesting ways during off hours.</p>
		<p class="add-event-tip-content">Interested in hosting something other than a WRKPRTY or WRKSHOP?</p>
		<p class="add-event-tip-content">Please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us</a> to let us know, so we can add this permission for you!</p>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	methods: {
		...mapActions(['setModalOpen'])
	}
}
</script>
